export const ADDRESS_TYPES = {
  User: 1,
  Mapped: 2,
  Verified: 3,
  UserCorrected: 4,
  NotSet: 5,
  AsMeasured: 6,
  Other: 7,
};

export const ADDRESS_MAPPER = {
  NotSet: 5,
  EGS: 11,
};

export const ENTITY_TYPES = {
  Parcel: 'parcel',
  Structure: 'structure',
};

export const EMPTY_ADDRESS = {
  address: '',
  address2: '',
  addressTypeId: null,
  city: '',
  country: '',
  county: '',
  mapperUsedId: ADDRESS_MAPPER.EGS,
  state: '',
  verificationResultTypeId: 2,
  verifierUsedId: ADDRESS_MAPPER.EGS,
  zip: '',
};

export const LOADING_ADDRESS = 'LOADING_ADDRESS';
export const ERROR_LOADING_ADDRESS = 'ERROR_LOADING_ADDRESS';
